Object.defineProperty(exports, '__esModule', {
  value: true
});
var _tslib = require('../_tslib-1246030c.js');
var integerFormatterOptions = {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
};
var IntegerFormatter = new Intl.NumberFormat("en-GB", integerFormatterOptions);
var IntegerFormatterWithDecimals = new Intl.NumberFormat("en-GB", _tslib.__assign(_tslib.__assign({}, integerFormatterOptions), {
  minimumFractionDigits: 2
}));
var FloatFormatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
var convertPenniesToPounds = function convertPenniesToPounds(pennies) {
  if (pennies === void 0) {
    pennies = 0;
  }
  return pennies / 100;
};
var formatCurrency = function formatCurrency(value, convertPennies, options) {
  if (convertPennies === void 0) {
    convertPennies = false;
  }
  var normalisedValue = convertPennies ? convertPenniesToPounds(value) : value;
  if (normalisedValue % 1 === 0) {
    if (options === null || options === void 0 ? void 0 : options.displayDecimalValue) {
      return IntegerFormatterWithDecimals.format(normalisedValue);
    }
    return IntegerFormatter.format(normalisedValue);
  }
  return FloatFormatter.format(normalisedValue);
};
exports.convertPenniesToPounds = convertPenniesToPounds;
exports.formatCurrency = formatCurrency;